(function () {
    "use strict";
    angular
        .module("harriApp")
        .service("googleTagManagerTrackingService", GoogleTagManagerIntegrationService);

    GoogleTagManagerIntegrationService.$inject = ['JobDetailsBus'];

    function GoogleTagManagerIntegrationService(JobDetailsBus) {
        var self = this;
        var brandTagManagerIdMap =  {
            SNOOZE : {
                TAG_MANGER_ID : 'GTM-WH3KMBQ',
                brand_ids: [1211587, 1211526, 1211553, 1211562, 1211569, 1234308, 2407682, 2904621, 3517730, 4800359, 5527325, 7453831]
            },
            YOUNGS: {
                TAG_MANGER_ID: 'GTM-KD6MVS3',
                brand_ids: [7720240]
            },
            HALL_AND_WOOD_HOUSE: {
                TAG_MANGER_ID: 'GTM-K2V5NKB',
                brand_ids: [5801535]
            },
        };
        var loadedTagManagers = [];

        self.init = function (brandIds) {
            self.destroy();
            for (var i in Object.keys(brandTagManagerIdMap)) {
                var mapItem = brandTagManagerIdMap[Object.keys(brandTagManagerIdMap)[i]];
                for (var j in brandIds) {
                    if (mapItem.brand_ids.indexOf(brandIds[j]) > -1) {
                        if (loadedTagManagers.indexOf(mapItem.TAG_MANGER_ID) === -1) {
                            loadedTagManagers.push(mapItem.TAG_MANGER_ID);
                            self.addGoogleTagManager(mapItem.TAG_MANGER_ID);
                            return;
                        }
                    }
                }
            }
        }

        self.initForJob = function (jobId, pjt) {
            JobDetailsBus.getJob(jobId, pjt)
                .then(function (jobDetails) {
                    self.init([jobDetails.top_parent_brand.id, jobDetails.brand.id, jobDetails.brand.group_id]);
                });
        }


        self.destroy = function () {
            for (var i in loadedTagManagers) {
                self.removeGoogleTagManager(loadedTagManagers[i]);
            }
            loadedTagManagers = [];
        };

        self.addGoogleTagManager = function (id) {
            (function (w, d, s, l, i) {
                w[l] = w[l] || [];
                w[l].push({
                    'gtm.start':  new Date().getTime(), event: 'gtm' + '.' + 'js'
                });
                var f = d.getElementsByTagName(s)[0],
                    j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : '';
                j.async = true;
                j.src =
                    'https://www.googletagmanager.com/gtm.js?id=' + id + dl;
                f.parentNode.insertBefore(j, f);
            })(window, document, 'script', 'dataLayer', id);

            var noscript = document.createElement('noscript');
            var iframe = document.createElement('iframe');
            iframe.src = 'https://www.googletagmanager.com/ns.html?id=' + id;
            iframe.height = 0;
            iframe.width = 0;
            iframe.style = 'display:none;visibility:hidden';
            noscript.appendChild(iframe);
            var s = document.getElementsByTagName('body')[0];
            s.parentNode.insertBefore(noscript, s);
        }


        self.trackApplicationCompletion = function (jobId) {
            console.log(loadedTagManagers);
            if (loadedTagManagers.indexOf(brandTagManagerIdMap['SNOOZE'].TAG_MANGER_ID) > -1) {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event': 'applicationComplete'
                });
                console.log('GTM-applicationComplete');
            }
        };

        self.removeGoogleTagManager = function (id) {
            var src = "googletagmanager.com/gtm.js?id=" + id;
            var gtm = document.querySelector("script[src*='" + src + "']");
            if (gtm) {
                gtm.parentNode.removeChild(gtm);
            }
            var noscript = document.querySelector('noscript');
            if (noscript) {
                noscript.parentNode.removeChild(noscript);
            }
        }
    }


})();